import type { WidgetConfig } from "@modernary/mui/components/widgetGrid";
import InternalGreetingWidget from "@/components/widgets/InternalGreetingWidget.vue";
import SolidWasteLinksWidget from "@/components/widgets/SolidWasteLinksWidget.vue";
import SustainabilityLinksWidget from "@/components/widgets/SustainabilityLinksWidget.vue";
import FacilitySiteDetailsWidget from "@/components/widgets/FacilitySiteDetailsWidget.vue";
import FacilitySiteLocationWidget from "@/components/widgets/FacilitySiteLocationWidget.vue";

export const widgetKeys = {
  internalGreeting: "internalGreeting",
  solidWasteQuickLinks: "solidWasteQuickLinks",
  sustainabilityQuickLinks: "sustainabilityQuickLinks",
  facilitySiteDetails: "facilitySiteDetails",
  facilitySiteLocations: "facilitySiteLocations",
} as const;

export type WidgetKey = keyof typeof widgetKeys;

export const widgetRegistry = new Map<string, WidgetConfig>([
  // Dashboard Widgets
  [
    widgetKeys.internalGreeting,
    {
      key: widgetKeys.internalGreeting,
      title: "Internal Greeting",
      defaultSize: {
        w: 1,
        h: 1,
        minW: 1,
        minH: 1,
      },
      getComponent: () => InternalGreetingWidget,
    },
  ],
  [
    widgetKeys.solidWasteQuickLinks,
    {
      key: widgetKeys.solidWasteQuickLinks,
      title: "Solid Waste Quick Links",
      defaultSize: {
        w: 1,
        h: 1,
        minW: 1,
        minH: 1,
      },
      getComponent: () => SolidWasteLinksWidget,
    },
  ],
  [
    widgetKeys.sustainabilityQuickLinks,
    {
      key: widgetKeys.sustainabilityQuickLinks,
      title: "Sustainability Quick Links",
      defaultSize: {
        w: 1,
        h: 1,
        minW: 1,
        minH: 1,
      },
      getComponent: () => SustainabilityLinksWidget,
    },
  ],
  // Facility Site Widgets
  [
    widgetKeys.facilitySiteDetails,
    {
      key: widgetKeys.facilitySiteDetails,
      title: "Facility Site Details",
      defaultSize: {
        w: 1,
        h: 1,
        minW: 1,
        minH: 1,
      },
      getComponent: () => FacilitySiteDetailsWidget,
    },
  ],
  [
    widgetKeys.facilitySiteLocations,
    {
      key: widgetKeys.facilitySiteLocations,
      title: "Facility Site Locations",
      defaultSize: {
        w: 1,
        h: 1,
        minW: 1,
        minH: 1,
      },
      getComponent: () => FacilitySiteLocationWidget,
    },
  ],
]);
